import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-row",
  "use": "icon-row-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-row\"><defs><style>#icon-row .cls-1{fill:#0df;}</style></defs><g id=\"icon-row_圖層_2\" data-name=\"圖層 2\"><g id=\"icon-row_圖層_1-2\" data-name=\"圖層 1\"><path class=\"cls-1\" d=\"M12,2V12H2V2H12m2-2H0V14H14V0Z\" /><rect class=\"cls-1\" x=\"2\" y=\"4\" width=\"4\" height=\"1\" /><rect class=\"cls-1\" x=\"2\" y=\"7\" width=\"4\" height=\"1\" /><rect class=\"cls-1\" x=\"2\" y=\"10\" width=\"4\" height=\"1\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol